import React from 'react'
import { connect } from 'react-redux'
import { compose } from 'redux'
import toJS from '../../../hoc/toJS'
import styles from '../../../../scss/newsletter/newsletter.styles.scss.js'
import getNewsletterRawData from '../functions/getNewsletterRawData'
import getFontFacesStyles from '../functions/getFontFacesStyles'
import newsletterConfig from '../../../newsletter-config.json'
import NewsletterPreview from '../present/NewsletterPreview'
import { generatePath } from 'react-router-dom'
import getNewsletterData from '../functions/getNewsletterData.js'


const mapStateToProps = (state, ownProps) => {
    const getData = getNewsletterRawData(ownProps.match.params.campaignId, false)

    return getData(state)
}


const NewsletterPreviewContainer = ({
    weeks, 
    week, 
    themeData, 
    logoData, 
    cinemasData, 
    addressData, 
    campaign, 
    newsletterData, 
    ads, 
    highlights, 
    movieData, 
    textItems, 
    imageItems, 
    socialMediaData, 
    currentCinemaUrl, 
    routesData,
    closingTextLines, 
    translation, 
    match, 
    goBackPath
}) => {
    const { cinemaData, stylesData, structureData, theme } = getNewsletterData(logoData, campaign, themeData, cinemasData, addressData, translation, week, weeks, routesData)
    const stylesFontFaces = getFontFacesStyles(currentCinemaUrl + '/', newsletterConfig.fontConfig[theme] ? newsletterConfig.fontConfig[theme] : [])
    const closePagePath = generatePath(goBackPath, match.params)

    return <NewsletterPreview
        closePagePath={closePagePath}
        stylesFontFaces={stylesFontFaces}
        styles={styles}
        stylesData={stylesData}
        structureData={structureData}
        cinemaData={cinemaData}
        newsletterData={newsletterData}
        ads={ads}
        textItems={textItems}
        imageItems={imageItems}
        socialMediaData={socialMediaData}
        highlights={highlights}
        movieData={movieData}
        currentCinemaUrl={currentCinemaUrl}
        closingTextLines={closingTextLines}
        translation={translation}
    />
}

export default compose(
    connect(mapStateToProps),
    toJS()
)(NewsletterPreviewContainer)
